import React, { useState } from 'react';
import { Typography, Tag, Popover, Space, Divider } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import '../App.css';

const { Text } = Typography;

const getStageColor = (stage) => {
  switch (stage?.toLowerCase()) {
    case 'prod':
    case 'production':
      return 'green';
    case 'pre-prod':
      return 'gold';
    case 'staging':
      return 'orange';
    case 'dev':
    case 'development':
      return 'blue';
    default:
      return 'default';
  }
};

const formatBuildTime = (isoString) => {
  if (!isoString) return 'Unknown';
  try {
    return new Date(isoString).toLocaleString();
  } catch (e) {
    return 'Invalid date';
  }
};

const Version = ({ npmVersion, style = {} }) => {
  const [visible, setVisible] = useState(false);
  const baseVersion = process.env.REACT_APP_VERSION || npmVersion || '1.2.3';
  const buildNumber = process.env.REACT_APP_BUILD_NUMBER || '123';
  const buildTime = process.env.REACT_APP_BUILD_TIME || '2021-01-01T01:02:03Z';
  const gitCommit = process.env.REACT_APP_GIT_COMMIT || 'abc123';
  const gitBranch = process.env.REACT_APP_GIT_BRANCH || 'main';
  const stage = process.env.REACT_APP_STAGE || 'dev';

  // Determine display version based on available information
  let displayVersion = baseVersion;
  let fullVersion = baseVersion;
  
  if (buildNumber) {
    // If we have a build number, show it in the main display
    displayVersion = `${baseVersion}+${buildNumber}`;
    fullVersion = `${baseVersion}+${buildNumber}`;
  }

  const popoverContent = (
    <div style={{ minWidth: 220 }}>
      <Space direction="vertical" size="small">
        <Space>
          <InfoCircleOutlined style={{ color: '#1890ff' }} />
          <Text strong>Version Details</Text>
        </Space>
        <Divider style={{ margin: '4px 0' }} />
        <Space>
          <Text type="secondary">Base Version:</Text>
          <Tag color="blue">{baseVersion}</Tag>
        </Space>
        {buildNumber && (
          <Space>
            <Text type="secondary">Build Number:</Text>
            <Tag color="purple">{buildNumber}</Tag>
          </Space>
        )}
        <Space>
          <Text type="secondary">Full Version:</Text>
          <Tag>{fullVersion}</Tag>
        </Space>
        <Space>
          <Text type="secondary">Environment:</Text>
          <Tag color={getStageColor(stage)}>{stage}</Tag>
        </Space>
        {buildTime && (
          <Space>
            <Text type="secondary">Build Time:</Text>
            <Text code>{formatBuildTime(buildTime)}</Text>
          </Space>
        )}
        {gitCommit && (
          <Space>
            <Text type="secondary">Git Commit:</Text>
            <Tag color="cyan">{gitCommit}</Tag>
          </Space>
        )}
        {gitBranch && (
          <Space>
            <Text type="secondary">Git Branch:</Text>
            <Tag color="magenta">{gitBranch}</Tag>
          </Space>
        )}
      </Space>
    </div>
  );

  return (
    <Popover
      content={popoverContent}
      trigger="hover"
      open={visible}
      onOpenChange={setVisible}
      placement="top"
    >
      <span
        className='menu-version'
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        version {displayVersion}
      </span>
    </Popover>
  );
};

export default Version;
